/**
 * @ngdoc directive
 * @name drvEmailCompose
 * 
 * @description
 * Used for composing email messages. Includes support for typical email properties including attachments.
 */

(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvEmailCompose', drvEmailCompose);

    drvEmailCompose.$inject = [];
    drvEmailComposeCtrl.$inject = ['TagsService', 'DialogService'];
    
    function drvEmailCompose () {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                email: '=',
                entityTemplate: '<',
                contacts: '=',
                emailAddressFields: '=',
                attachments: '=',
                showCc: '=',
                showBcc: '=',
                showReplyTo: '=',
                showPreheader: '=',
                showFromAddress: '=',
                showEntitySelector: '='
            },
            controller: drvEmailComposeCtrl,
            controllerAs: 'drvCtrl',
            bindToController: true,
            templateUrl: 'app/email/email-compose.tmpl.html'
        };

        return directive;

        function link(scope, element, attrs) {
        }
    }

    function drvEmailComposeCtrl(TagsService, DialogService) {
        /* jshint validthis:true */
        var drvCtrl = this;
        drvCtrl.selectFromAddress = selectFromAddress;

        activate();

        function activate() {
            loadTags();

            drvCtrl.contactsWithoutFieldReference = _.filter(drvCtrl.contacts, function (contact) {
                return !contact.ReferenceContact;
            });

            drvCtrl.contactsWithFieldReference = _.filter(drvCtrl.contacts, function (contact) {
                return contact.ReferenceContact;
            });
        }

        function selectFromAddress() {
            drvCtrl.email.changeFromAddress();
        }

        /**
         * Load tags into the drvCtrl.tags variable.
         *
         * @returns {promise} A promise that resolves once the tags are loaded, or an error occurred.
         */
        function loadTags() {
            return TagsService.query({ tagUsage: 'Email' })
                .then(getTagsOk, getTagsError);

            function getTagsOk(data) {
                drvCtrl.tags = data.Tags;
            }

            function getTagsError(response) {
                DialogService.error('Error fetching Tags', response);
            }
        }
    }
})();